import { Pipe, PipeTransform } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Pipe({
    name: 'downloadUrl',
    standalone: false
})

    export class DownloadUrlPipe implements PipeTransform {

        constructor(public storage: AngularFireStorage){}

        transform(featuredPhoto: any): any {
            let photo = this.storage.ref(featuredPhoto).getDownloadURL();
            
            return photo;
        }
    }
